// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__27Ouf","content":"RecentSearches_content__5zI67"};